import React from 'react'
import { WidgetProps } from '@rjsf/utils'

import { useBotId } from '../../../../../store/flow'
import { useLoadedBotApiUrl } from '../../../../../store/app'

export const PreprocessingLogButtonWidget: React.FC<WidgetProps> = ({ formContext }) => {
  const stepId = formContext?.initialFormData?.id

  const botId = useBotId()
  const apiUrl = useLoadedBotApiUrl()

  const isApiUrlForHosting = apiUrl?.endsWith('/api')

  if (!stepId || !isApiUrlForHosting) {
    return null
  }

  const href = `/bots/${botId}/calls/validator/step/${stepId}`

  return (
    <p className="col-xs-3 col-xs-offset-9 text-right array-item-add">
      <a href={href} target="_blank" rel="noopener noreferrer">
        Open validation log
      </a>
    </p>
  )
}
